import styled from 'styled-components';

import folder from '../../../assets/image/folder/folder.svg';
import upload from '../../../assets/image/upload/upload.svg';
import remove from '../../../assets/image/remove/remove.svg';

export { folder, upload, remove };

export const Container = styled.div`
	position: sticky;
	bottom: 14rem;
	right: 0;
	border-radius: 1.6rem;
	border: solid 1px #dcdcdc;
	background-color: #fff;
	//opacity: 0.5;
	display: grid;
	padding: 1.5rem 2rem 2rem;
	gap: 1rem;
	min-width: 200px;
	${({ theme }) => theme.common.wh('100%', 'auto')}
`;

export const Top = styled.div`
	gap: 1rem;
	${({ theme }) => theme.common.wh('100%', 'auto')}
	${({ theme }) => theme.common.flex('column', 'flex-start', 'flex-start')}

	h1 {
		font-size: 1.7rem;
		font-family: Helvetica-Bold;
	}

	.buttons {
		${({ theme }) => theme.common.wh('100%', 'auto')}
		${({ theme }) => theme.common.flex('row', 'center', 'space-between')}
	}

	.hidden {
		visibility: hidden;
	}

	button {
		background-color: transparent;
		//min-width: 15rem;
		border-radius: 2rem;
		border: solid 1px #dcdcdc;
		padding: 0.4rem;
		box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.16);
		//aspect-ratio: 1 / 1;
	}
`;

export const Table = styled.table`
	border-radius: 1.5rem;
	overflow: hidden;
	background-color: #fff;
	box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.16);
	font-size: 1.25rem;
	line-height: 1.2;
	${({ theme }) => theme.common.wh('100%', 'auto')}

	th, td {
		border-collapse: collapse;
		vertical-align: middle;
		border: 1px solid ${({ theme }) => theme.color.regular};
		${({ theme }) => theme.common.wh('100%', '4rem')}
	}
	th {
		text-align: center;
		padding: 1rem;
		width: 35%;
		background-color: ${({ theme }) => theme.color.lightGreen};

		span {
			font-size: 1rem;
		}

		.required {
			color: ${({ theme }) => theme.color.red};
			margin-left: 0.2rem;
			font-size: 1.1rem;
		}

		&.narrow {
			width: 20%;
		}
	}
	td {
		position: relative;
		text-align: left;
		padding: 0.5rem 1rem;
		width: 65%;

		span {
			display: inline-block;
			word-break: keep-all;
			//white-space: nowrap; /* span이 넘칠 경우 줄바꿈 방지 */
		}

		div {
			position: relative;
			gap: 0.5rem;
			${({ theme }) => theme.common.flex('row', 'center', 'space-between')};
		}
		.column {
			${({ theme }) => theme.common.wh('100%')}
			${({ theme }) => theme.common.flex('column', 'flex-start', 'center')};
			input {
				width: 80%;
			}
			.errorInfo {
				color: ${({ theme }) => theme.color.red};
			}
		}

		.stack {
			align-items: stretch;
			flex-direction: column;
			gap: 0.8rem;

			> div {
				width: 100%;
			}
		}

		.honorificHelp {
			color: #666;
			font-size: 0.9rem;
			line-height: 1.4;
		}

		.livingPlaceSelects {
			display: flex;
			gap: 0.5rem;

			select:first-child {
				flex: 0 0 60%;
				max-width: 60%;
			}

			select:last-child {
				flex: 0 0 40%;
				max-width: 40%;
			}
		}
	}

	input {
		padding: 0.2rem;
		outline: none;
		border-radius: 0.5rem;
		border: 1px solid ${({ theme }) => theme.color.regular};
		${({ theme }) => theme.common.wh('100%')}

		&::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
			-webkit-appearance: none;
			margin: 0;
		}
	}
	.error {
		border: 1px solid ${({ theme }) => theme.color.red};
	}

	&.detailTable {
		th {
			width: 20%;
		}
		td {
			width: 80%;
		}
	}
`;

export const TableGrid = styled.div`
	display: grid;
	gap: 1rem;
	grid-template-columns: 1fr;
	${({ theme }) => theme.common.wh('100%', 'auto')}

	${({ theme }) => theme.device.tablet} {
		gap: 5%;
		grid-template-columns: 30% 65%;
		align-items: start;
	}
`;

export const FaceBox = styled.div`
	max-height: 6rem;
	height: 18%;
	border-radius: 0.5rem;
	margin: 0.5rem 0;
	overflow: hidden;
	background-color: ${({ theme }) => theme.color.gray};
	${({ theme }) => theme.common.flex('row', 'center', 'space-between')};

	span {
		white-space: nowrap;
	}

	.folder {
		object-fit: cover;
		padding: 0.7rem 0 0.7rem 0.5rem;
		${({ theme }) => theme.common.wh('20%', '100%')};
	}
	button {
		border: none;
		background-color: transparent;
		padding: 0;
		${({ theme }) => theme.common.wh('auto', '100%')};
		${({ theme }) => theme.common.flex()};
	}

	.loading {
		${({ theme }) => theme.common.wh('auto', '4rem')};
		${({ theme }) => theme.common.flex()};
	}

	label {
		height: 100%;
	}

	input {
		display: none;

		/* 커스텀 스타일 또는 배경 이미지 적용 */
		/* 예시: 배경 이미지 적용 */
		width: 50px; /* 원하는 너비 설정 */
		height: 50px; /* 원하는 높이 설정 */
		cursor: pointer;
	}
`;

export const ButtonWrap = styled.div`
	gap: 1rem;
	${({ theme }) => theme.common.wh('100%', 'auto')}
	${({ theme }) => theme.common.flex('row', 'center', 'flex-end')};
	justify-content: flex-end;
	align-items: center;

	button {
		background-color: transparent;
		//min-width: 15rem;
		border-radius: 2rem;
		border: solid 1px #dcdcdc;
		padding: 0.5rem;
		box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.16);
		${({ theme }) => theme.common.wh('10%', '100%')}
	}
`;

export const SpinnerWrap = styled.div`
	width: 3rem;
	height: 3rem;
	display: block !important;
	& div {
		display: block !important;
		position: absolute !important;
		left: 20% !important;
	}
	& > div > div {
		width: 100%;
		height: 100%;
	}
`;
